import { Component, OnInit, Input } from '@angular/core';
import { HandlerManager           } from 'src/app/managers/handler/handler.manager';
import { SessionManager           } from 'src/app/managers/session/session.manager';
import { LoadingManager           } from 'src/app/managers/loading/loading.manager';
import { User                     } from 'src/app/beans/login/user/user.bean';
import { OMOperator               } from 'src/app/beans/operator/operator.bean';
import { OOperatorCounter         } from 'src/app/beans/operator/operator.counter.bean';

@Component({
  selector: 'text-card',
  templateUrl: './c.text.card.html',
  styleUrls: ['./c.text.card.scss']
})
export class CTextCard implements OnInit 
{
  values: OOperatorCounter[] = []
  operatorId: number

  @Input('operator') set _operator(operator: OMOperator)
  {    
    if(operator) this.init(operator.id)
  }

  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
  ) {}

  ngOnInit(): void 
  {}

  async init(operatorId: number)
  {
    this.operatorId = operatorId
    
    this.values = await this.retriveValues( operatorId )
  }

  async retriveValues( operatorId: number )
  {
    const user = this._session.user().get()

    if(!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    let response = null
    response = await this._handler.operator().getOperatorCounter((user as User).token, operatorId)

    this._loader.stop()

    if ( !response      ) return 
    if ( !response.list ) return 

    return response.list as OOperatorCounter[];
  }
}
